function NumericValue({ children }) {
  return children || "0";
}

export default NumericValue;
